import { combineReducers } from 'redux';
import assignments from './assignment.reducer';
import student_assignment from './student_assignment.reducer';

const assignmentAppReducer = combineReducers({
    assignments,
    student_assignment,
});

export default assignmentAppReducer;


// WEBPACK FOOTER //
// src/main/content/assignment/store/reducers/index.js